import React, { useState, useEffect, useContext, useRef} from "react";
import { Button } from "react-bootstrap";
import { Select } from "../../components/Core";
import { getCountry } from './../../graphql/queries';
import { API, graphqlOperation } from 'aws-amplify'; 
import GlobalContext from "../../context/GlobalContext";
import ConfirmMessages from "../../utils/confirmMessages";
import Icon from '@mui/material/Icon';
import { Helmet } from "react-helmet";
const imgP = "assets/image/patterns/globe-pattern.png";
const imgH = "assets/image/l3/png/hero-image-1.png";
 
// Styles for the in-page video player UI tweaks
const videoStyles = {
    container: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
      padding: '10px',
                        paddingLeft: 'clamp(12px, 4vw, 60px)',
                        paddingRight: 'clamp(12px, 3vw, 30px)'
    },
        video: () => ({
      width: '100%',
      maxWidth: '820px',
            position: 'relative',
            display: 'block',
            top: 'auto',
            left: 'auto',
            transform: 'none',
            border: '2px solid #F7921E',
      borderRadius: '6px',
      boxShadow: 'none',
            filter: 'none'
    }),
    playButton: {
      position: 'absolute',
            top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
      zIndex: 5,
      cursor: 'pointer'
    },
    playIcon: {
            size: 'clamp(52px, 10vw, 96px)',
            color: '#F7921E',
      lineHeight: 1
    }
};
 

const Hero = () => {
    const gContext = useContext(GlobalContext);
    const [toggleSearchMenu, setToggleSearchMenu] = React.useState(false);
    const maintenance = process.env.REACT_APP_SHOW_MAINTENANCE_PROMPT;
    const [searchMode, setSearchMode] = React.useState('expert');
    const [countriesList, setCountriesList] = useState([{}]);
    const [values, setValues] = React.useState({  keyword: '' });
    const [playIcon, setplayIcon] = React.useState(true);  
    const [currentTime, setCurrentTime] = React.useState(0);  
    const [duration, setDuration] = React.useState(0);  
    const videoRef = useRef(null);
    const s3URL = process.env.REACT_APP_AWS_S3_URL;
    useEffect(() => {

        getCountries();

    }, []);
    const handleChange = (e, name) => {

        const value = e;
        switch (name) {
            case "country":
                setValues({ ...values, ["country"]: value.value, ["countryId"]: value });
                break;
            case "keyword":
                var regex = new RegExp('[^0-9a-zA-Z-,_.\:\s ]+');

                if (!regex.test(e.target.value)) {
                    setValues({ ...values, ["keyword"]: e.target.value });                   
                }                
                break;
            default:
                break;
        }
    }
 
    function navigateSearch() {
        
        localStorage.setItem('jobSearch', JSON.stringify(values));
        if (searchMode == 'job') {
            window.location.href = "/searchjob";
             
        }
        else
            window.location.href = "/searchexpert";

    }
    async function getCountries() {
      
        try {
            const result = await API.graphql(graphqlOperation(getCountry));
            if (result.data && result.data?.countries) {
                setCountriesList(result.data.countries)

                let countlist = [];
                result.data.countries.map((value) => (
                    countlist.push({ code: value.code, value: value.id, label: value.name })));
                setCountriesList(countlist);
                gContext.setCountriesList(countlist);

            }
            else {
                //if (result.errors && result.errors.length > 0) {

                //    if (result.errors[0]?.originalError.response.status == "403")
                //        gContext.setErrorModal(ConfirmMessages.errorAccessDenied);
                //    else
                //        gContext.setErrorModal(result.errors[0]?.message);

                //    gContext.toggleErrorMessage(true);
                //}
                //else if (result.message) {
                //    if (result.message.includes("403"))
                //        gContext.setErrorModal(ConfirmMessages.errorAccessDenied);
                //    else
                //        gContext.setErrorModal(result.message);
                //    gContext.toggleErrorMessage(true);
                //}

            }
        } catch (e) {
            //if (e.errors && e.errors.length > 0) {

            //    if (e.errors[0]?.originalError.response.status == "403")
            //        gContext.setErrorModal(ConfirmMessages.errorAccessDenied);
            //    else
            //        gContext.setErrorModal(e.errors[0]?.message);

            //    gContext.toggleErrorMessage(true);
            //}
            //else {
            //    if (e.message.includes("403"))
            //        gContext.setErrorModal(ConfirmMessages.errorAccessDenied);
            //    else
            //        gContext.setErrorModal(e.message);
            //    gContext.toggleErrorMessage(true);
            //}
           
        }
    }
    function toggleSearch() {
        let current = toggleSearchMenu;
        setToggleSearchMenu(!current);

    }
    function toggleSearchMode(mode)
    {
        setSearchMode(mode);
        toggleSearch();
        document.getElementById("keyword").focus();

    }
    function showSearchOption()
    {
        setToggleSearchMenu(true);
       
    }
    const handleKeyDown = (e) => {
        if (e.charCode === 13) {
           
            navigateSearch();
        }
    };
    return (
        <>
            {/* <Helmet>
                <title>Compliance Marketplace | Syncuppro </title>
                <meta name="description" content="Ensure compliance and enhance efficiency with our auditing services for quality management systems. Identify risks and achieve continuous improvement." />
                <link rel="canonical" href={window.location.origin} />
            </Helmet> */}

            <div className={maintenance == "true" ? "page-wrapper p-0":"page-wrapper"}>




                <section className="section welcome-sec bg-gray p-relative gradient-img ">
                    <div className="home-hero-wrap">
                    <div className="left-sec">
                        <div className="section-title">
                            
                            <h1>Fast & cost effective way to <span className="text-theme">hire compliance expert</span></h1>
                            <p className="section-desc">Syncuppro is a marketplace that connects growing companies with vetted compliance experts to get certified faster at a fraction of Big 4 costs. Get started for free.</p>
                        </div>
                         

                        <div className="search-group ">
                            <div className="search-info hero-search-info p-relative  ">
                                <input type="text" className="form-control form-control-lg hero-search-input d-none d-lg-block d-xl-block d-md-block " placeholder={(searchMode == 'job') ? "Compliance Standard i.e.'ISO 9001 Consultant'" : " Compliance Standard i.e.'ISO 9001 Consultant'"} onKeyPress={(e) => handleKeyDown(e)} onChange={(e) => handleChange(e, 'keyword')} onKeyUp={(e) => handleChange(e, 'keyword')}/>

                                <input type="text" className="form-control form-control-lg hero-search-input d-block d-sm-none " placeholder={(searchMode == 'job') ? "ISO 9001 Consultant" : "ISO 9001 Consultant"} onKeyPress={(e) => handleKeyDown(e)} onChange={(e) => handleChange(e, 'keyword')} onKeyUp={(e) => handleChange(e, 'keyword')} /><button type="button" onClick={() => {
                                    navigateSearch();

                                }} className="btn btn-orange search-btn hero-search-btn rounded-circle" aria-label="Search"><Icon className="text-white m-icon material-icons">search</Icon></button>
          </div>
                            </div>

                        </div> 

    <div className="right-sec" style={{ paddingRight: 'clamp(0px, 2vw, 40px)' }}>
                            <div className=" video-container " style={videoStyles.container}>
                          <video
                            id="myVideo"
                            ref={videoRef}
                            className="video align-middle"
                            playsInline
                                                        webkit-playsinline="true"
                                                        preload="metadata"
                            loop
                            style={videoStyles.video()}
                        onClick={(e) => {
                          const v = videoRef.current || e.target;
                          if (v.paused) {
                            v.play();
                          } else {
                            v.pause();
                          }
                        }}
                        onLoadedMetadata={(e) => { setDuration(e.target.duration); }}
                        onTimeUpdate={(e) => { setCurrentTime(e.target.currentTime); }}
                        onPlay={() => setplayIcon(false)}
                        onPause={() => setplayIcon(true)}
                      >
                          <source src={s3URL + "website/SyncupproPurpose.mp4#t=0.001"} type="video/mp4"/>                              
                      </video>
                      <div
                        className="play-button text-center  "
                        id="playButton"
                        style={videoStyles.playButton}
                        onClick={() => {
                          const v = videoRef.current;
                          if (!v) return;
                          if (v.paused) {
                            v.play();
                          } else {
                            v.pause();
                          }
                        }}
                      >
                        {playIcon && (
                                                    <svg
                                                        className="pointer"
                                                        style={{ width: videoStyles.playIcon.size, height: videoStyles.playIcon.size }}
                            viewBox="0 0 48 48"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                          >
                                                        <circle cx="24" cy="24" r="18" fill="#F7921E" stroke="#F7921E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M20 16 L32 24 L20 32 Z" fill="#FFFFFF" stroke="#FFFFFF" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        )}
                      </div>
                      {!playIcon && (
                        <input
                          type="range"
                          id="tracker-bar"
                          value={currentTime}
                          min="0"
                          max={duration}
                          step="0.1"
                          onInput={(e) => {
                            const v = videoRef.current;
                            if (!v) return;
                            const val = parseFloat(e.target.value);
                            v.currentTime = val;
                            v.play();
                            setCurrentTime(val);
                          }}
                        />
                      )}
                  </div>
                                </div>
                            </div>
                    </section> 

    

                                    

                

     

   


            </div>


            <div className="bg-squeeze pt-26 pt-md-26 pt-lg-26 pt-xl-26 position-relative z-index-1 overflow-hidden d-none">
                {/* <!-- .Hero pattern --> */}
                <div className="pos-abs-tr w-50 z-index-n2 h-100">
                    <img src={imgP} alt="" className="gr-opacity-1" />
                </div>
                {/* <!-- ./Hero pattern --> */}
                <div className="container">
                    <div className="row position-relative align-items-center">
                        <div
                            className="col-xxl-6 col-xl-7 col-lg-8 col-md-12 pt-lg-13 pb-lg-33 pb-xl-34 pb-md-33 pb-10"
                            data-aos="fade-right"
                            data-aos-duration="1000"
                            data-aos-delay="500"
                        >
                            <h2 className="font-size-10 mb-12 pr-md-30 pr-lg-0">
                                Hire the Best Compliance Expert for your needs
              </h2>
                            <p className="font-size-5 w-75">
                                Ensure compliance success with the industry's top expert by your side.
                  </p>
                            <div className="">
                                {/* <!-- .search-form --> */}
                                <form

                                    className="search-form"
                                    data-aos="fade-up"
                                    data-aos-duration="800"
                                    data-aos-delay="500"
                                >
                                    <div className="filter-search-form-2 bg-white rounded-sm shadow-7 py-1 pl-6">
                                        <div className="filter-inputs position-relative" onMouseLeave={toggleSearch}>
                                            <div className=" " onMouseOver={showSearchOption} >

                                                <input
                                                    className="form-control focus-reset pl-5 "
                                                    type="text"
                                                    id="keyword"
                                                    name="keyword" defaultValue={values.keyword} Value={values.keyword}
                                                    placeholder={(searchMode == 'job') ? "Compliance Standard i.e.'ISO 9001 Consultant'" : " Six Sigma Specialist"} onKeyPress={(e) => handleKeyDown(e)} onChange={(e) => handleChange(e, 'keyword')} onKeyUp={(e) => handleChange(e, 'keyword')}
                                                />
                                                {toggleSearchMenu === true && <div className="focus-reset mt-12  w-100 pos-abs-tl   z-index-supper bg-white ">

                                                    <a className="dropdown-item  font-size-4 font-weight-semibold line-height-1p2 text-gray " onClick={() => (toggleSearchMode('job'))}>
                                                        <i className="fa fa-briefcase text-green px-3"></i>Jobs<br />
                                                        <span className="font-size-2 px-10" > "ISO 27001"</span>
                                                    </a>


                                                    <a className="dropdown-item  font-size-4 font-weight-semibold line-height-1p2 text-gray " onClick={() => (toggleSearchMode('expert'))}>
                                                        <i className="fa fa-user text-green px-3"></i>Experts<br />
                                                        <span className="font-size-2 px-10" > "Six Sigma Specialist"</span>
                                                    </a>

                                                </div>}

                                                {/*    <span className="h-100 w-px-50 pos-abs-tl d-flex align-items-center justify-content-center font-size-6 pointer d-none" style={{ cursor: 'pointer' }} onClick={toggleSearch} data-toggle="tooltip" data-placement="right" title="Click here to change search option.">
                                                    <i className="icon icon-zoom-2 text-primary font-weight-bold pointer"></i>
                                                 
                                                </span> */}




                                            </div>

                                            {/* <!-- .select-city starts --> */}
                                            <div className="form-group position-relative d-none">
                                                <Select name="country" options={countriesList} placeholder="Select..." value={values.countryId}
                                                    className="pl-8 h-100 arrow-3 font-size-4 d-flex align-items-center w-100"
                                                    border={false}
                                                    onChange={(e) => handleChange(e, 'country')}
                                                />
                                                <span className="h-100 w-px-50 pos-abs-tl d-flex align-items-center justify-content-center font-size-6">
                                                    <i className="icon icon-pin-3 text-primary font-weight-bold"></i>
                                                </span>
                                            </div>


                                        </div>
                                        <div className="button-block pt-5 justify-content-end ">
                                            <Button
                                                type="button"
                                                className="line-height-reset btn btn-submit btn-small   px-3 mx-auto "
                                                style={{ minWidth: '100px', height: '40px' }}
                                                onClick={() => {
                                                    navigateSearch();

                                                }}>

                                                <i className="icon icon-zoom-2 text-white font-weight-bold pointer font-size-5 pr-3"></i> {(searchMode == 'job') ? "Jobs" : "Experts"}
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                                {/* <!-- ./search-form --> */}

                            </div>
                        </div>
                        {/* <!-- Hero Right Image --> */}
                        <div
                            className="col-lg-6 col-md-4 col-sm-6 col-xs-6 col-8 pos-abs-tr z-index-n1 position-static position-md-absolute mx-auto ml-md-auto"
                            data-aos="fade-left"
                            data-aos-duration="1000"
                            data-aos-delay="500"
                        >
                            <div className=" ml-xxl-23 ml-xl-12 ml-md-7">
                                <img src={imgH} alt="" className="w-100" />
                            </div>
                        </div>
                        {/* <!-- ./Hero Right Image --> */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Hero;
